module.exports = __webpack_public_path__ + "static/media/b3_p3_clickable.79e133ff.mp3";